// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"071ba872","110":"307e4187","180":"f8a49f40","191":"e7336d53","245":"3da3a0d3","336":"406594d0","363":"3723b004","654":"607e2822","668":"f1873816","674":"44b37104","729":"75390faf","818":"fca1ddee","831":"0cea05a1","900":"b1202537"}[chunkId] + ".chunk.js";
};